import tokeys from 'tokeys';

export const slideoutMode = tokeys(['view', 'edit', 'create']);
